import * as React from 'react';
import './Activity.less';
import { LocalizeContextProps, withLocalize, Translate } from 'react-localize-redux';
import bindAllOfThis from 'src/utils/BindThisHelper';
import StudentActivityDTO from 'src/models/activity/StudentActivityDTO';
import { Game } from "src/constants/Games";
import AudioPlayer from "src/components/common/AudioPlayer";
import AudioTranslations from "src/constants/AudioTranslations";
import { Track } from 'src/providers/TelemetryService';

interface ActivityIntroProps extends LocalizeContextProps {
    activity: StudentActivityDTO;
    currentGame: Game;
    onNext: () => void;
    onBack: () => void;
}

class ActivityIntro extends React.Component<ActivityIntroProps> {
    constructor(props: ActivityIntroProps) {
        super(props);
        bindAllOfThis(this, ActivityIntro.prototype);
    }

    componentDidMount(): void {
        document.addEventListener("keydown", this.handleKeyPress, false);
        const { activity, currentGame } = this.props;
        const activityType = activity.isSurvey ? 'Survey' : 'Quiz';
        const activityName = `${currentGame.name}_${currentGame.grade.shortName}${currentGame.planet.name}_${activityType}`;
        Track.Activity(activity.isSurvey ? 'SURVEY' : 'QUIZ', activityName, activity.id, 'INTRO', 1);
    }

    componentWillUnmount() {
        // Remove the event when we change pages
        document.removeEventListener("keydown", this.handleKeyPress, false);
    }

    handleKeyPress(event): void {
        if (event.key === "ArrowRight") {
            if (this.hasNextButton()) {
                this.props.onNext();
            }
        }
        else if (event.key === "ArrowLeft") {
            if (this.hasBackButton()) {
                this.props.onBack();
            }
        }
    }

    hasNextButton(): boolean {
        return true;
    }

    hasBackButton(): boolean {
        return true;
    }

    render() {
        if (this.props.activity == null || this.props.activity.id < 1) {
            return null;
        }

        let audioTrans = AudioTranslations.FindByKeyAndLanguage(this.props.activity.introduction.audioKey, this.props.activeLanguage.code);

        return <div className="activity-form">
            <AudioPlayer
                audioURL={audioTrans.url}
                isPlaying={true} />
            <p>{this.props.activity.introduction.text}</p>
        </div>;
    }
}

export default withLocalize(ActivityIntro);



// WEBPACK FOOTER //
// ./src/components/student/ActivityIntro.tsx